import React from 'react'

import { ButtonClean, Icon, Loader, PriceString, Tooltip } from '@fourthwall/components'
import { QuestionMarkIcon } from '@fourthwall/icons'

import { useThirdPartyLogisticsOptionsQuery } from '../../../../../../../hooks/useThirdPartyLogisticsOptionsQuery'
import * as S from './styled'

export const AssistedShippingContent = () => {
  const { thirdPartyLogisticsOptionsQuery } = useThirdPartyLogisticsOptionsQuery()

  if (!thirdPartyLogisticsOptionsQuery.data) {
    return (
      <S.LoaderWrapper>
        <Loader size="medium" />
      </S.LoaderWrapper>
    )
  }

  const { minimumStorageFee, shippingFirstItemFee, shippingNextItemFee } =
    thirdPartyLogisticsOptionsQuery.data

  return (
    <>
      <S.Heading>I want Fourthwall to ship orders</S.Heading>
      <S.Content>
        <p>
          Send your products to us in bulk and we’ll ship orders and handle customer support for
          you.{' '}
          <ButtonClean
            label="Learn more"
            href="https://help.fourthwall.com/hc/en-us/articles/13331284092187-Fourthwall-fulfillment-service-guide"
            target="_blank"
          />
        </p>
        <div>
          <strong>Pricing</strong>
        </div>
        <S.List>
          <li>
            <strong>When we ship an order:</strong>
            <br />
            <PriceString
              value={shippingFirstItemFee.value}
              currency={shippingFirstItemFee.currency}
            />{' '}
            for the first item +{' '}
            <PriceString
              value={shippingNextItemFee.value}
              currency={shippingNextItemFee.currency}
            />{' '}
            for each additional item in the shipment
          </li>
          <li>
            <strong>Storage fees:</strong>
            <br />
            <S.WithTooltipSpan>
              From{' '}
              <PriceString value={minimumStorageFee.value} currency={minimumStorageFee.currency} />
              /month per item{' '}
              <Tooltip
                placement="top"
                reference={<Icon component={QuestionMarkIcon} height={12} width={12} />}
              >
                <div>
                  Storage fees range from&nbsp;
                  <PriceString
                    value={minimumStorageFee.value}
                    currency={minimumStorageFee.currency}
                    minimumFractionDigits={2}
                  />
                  -$1.00/month per item based on the size of the item being stored. As an example, a
                  t-shirt is $0.45/month to store.
                </div>
              </Tooltip>
            </S.WithTooltipSpan>
          </li>
        </S.List>
      </S.Content>
    </>
  )
}
